import {useApiMutation} from './api';
import {ValidateDomains} from '../../shared/api/definitions/root';

export const useValidateDomains = () => {
  return useApiMutation(ValidateDomains);
};
